export const NAME = "openedItems";

/**
 * Text použitý pro otevřené položky, jejichž formuláře nemají položku menu a nemají načtený
 * text z custom title.
 */
export const NO_MENU_ITEM_LABEL = "...";

/**
 * Pomocná funkce pro vytvoření typu akce
 * @param actionTypeName Typ akce
 */
const createActionType = (actionTypeName: string) => `${NAME}/${actionTypeName}`;

export const SET_LABEL_INFO = createActionType("SET_LABEL_INFO");
export const REMOVE_LABEL_INFO = createActionType("REMOVE_LABEL_INFO");
export const SET_GROUP_MAP_ITEM = createActionType("SET_GROUP_MAP_ITEM");
export const REMOVE_GROUP_MAP_ITEM = createActionType("REMOVE_GROUP_MAP_ITEM");
export const SET_OPENED_ITEM_NUMBER = createActionType("SET_OPENED_ITEM_NUMBER");
export const REMOVE_OPENED_ITEM_NUMBER = createActionType("REMOVE_OPENED_ITEM_NUMBER");
export const SET_NUMBERING_GROUP = createActionType("SET_NUMBERING_GROUP");
export const REMOVE_NUMBERING_GROUP = createActionType("REMOVE_NUMBERING_GROUP");
